module.exports = __webpack_public_path__ + "img/venom_davidsm.gm.a9334fb.png";